import { FC } from 'react';
import { MedusaLineItem } from 'lib/home/generated/types/api';
import { CartItem } from './CartItem';

export interface CartItemListProps {
  items: MedusaLineItem[];
}

export const CartItemList: FC<CartItemListProps> = ({ items }) => (
  <div className="flex flex-col gap-6">
    {items.map((item, index) => (
      <CartItem item={item} key={item.id} index={index} />
    ))}
  </div>
);
